import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Spinner from '../common/Spinner';

const TransactionHistory = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/passenger/transactions')
      .then(res => setTransactions(res.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;

  return (
    <div className="glass-card fade-in">
      <h2>My Transactions</h2>
      <table className="report-table">
        <thead>
          <tr>
            <th>ID</th><th>Vehicle</th><th>Route</th><th>Amount</th><th>Status</th><th>Date</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map(tx => (
            <tr key={tx.id}>
              <td>{tx.id}</td>
              <td>{tx.plate_number}</td>
              <td>{tx.route_from} → {tx.route_to}</td>
              <td>${tx.amount}</td>
              <td><span className={`status-badge status-${tx.status}`}>{tx.status}</span></td>
              <td>{new Date(tx.created_at).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <style>{`
        .report-table {
          width: 100%; border-collapse: collapse; margin-top: 1rem;
        }
        .report-table th, .report-table td {
          padding: 0.75rem; text-align: left; border-bottom: 1px solid var(--border);
        }
        .report-table th { font-weight: 600; color: var(--text-secondary); }
      `}</style>
    </div>
  );
};
export default TransactionHistory;